<template>
    <li class="relative">
        <button
            @click="toggleForm"
            :aria-expanded="isDropdownVisible"
            :class="{
                'border-keyline-primary-invert border-b-0 rounded-b-none': isDropdownVisible,
            }"
            class="
                bg-gray-120
                dark:bg-gray-700
                border 
                border-keyline-primary
                hover:border-keyline-primary-invert
                flex 
                gap-3 
                group 
                items-center 
                leading-none 
                max-w-full 
                relative 
                rounded 
                text-left 
                w-full 
                p-4
            "
        >
            <BaseSvg name="ArrowForward" aria-hidden="true" class="fill-v2-gray-70 shrink-0 size-5 dark:fill-v2-gray-90" />
            <span class="flex gap-1 grow items-center leading-none min-w-0 text-sm">
                <span class="shrink-0 text-v2-gray-20 dark:text-v2-gray-130 dark:group-hover:text-v2-white">Share by email</span>
                <span v-if="isDropdownVisible" aria-hidden="true" class="gap-1 grow inline-flex items-center justify-between min-w-0">
                    <span class="text-v2-gray-70 truncate dark:text-v2-gray-80">/ Cut sheet – 4040XP-30 689</span>
                    <BaseSvg name="ExpandLess" class="fill-v2-gray-70 shrink-0 size-[18.5px] dark:fill-v2-gray-90" />
                </span>
            </span>
        </button>
        <form
            v-if="isDropdownVisible" 
            :class="{
                'border-keyline-primary-invert': isDropdownVisible,
            }"
            class="
                -mt-1 
                p-3 
                rounded-b 
                border-t-0
                border
                border-keyline-primary
                relative
            "
            >
            <label for="email-address" class="sr-only">Email address</label>
            <div class="
                bg-v2-gray-130 
                flex 
                gap-2 
                rounded
                dark:bg-v2-gray-60
                dark:px-0 
                dark:rounded-none"
            >
                <input
                    v-model="form.email"
                    type="email"
                    name="email-address"
                    id="email-address"
                    ref="emailInput"
                    placeholder="Email address"
                    class="border-v2-blue grow rounded dark:bg-v2-gray-40"
                >
                <div class="relative w-16">
                    <!--
                    When this form is submitted:
                    - Hide the below button.
                    - On the `<span>` that follows it, add class `confirmation-run`.
                    -->
                    <button
                        @click.prevent="sendEmail"
                        :disabled="isSending"
                        v-if="!sent"
                        type="button"
                        ref="sendButton"
                        class="bg-v2-gray-50 font-medium h-full leading-none px-4 py-3 rounded shrink-0 text-v2-white text-xs dark:bg-v2-gray-60 dark:border dark:border-v2-gray-10 dark:text-v2-gray-130"
                    >
                        Send
                    </button>
                    <span
                        ref="sendButton"
                        class="confirmation-ready"
                        aria-hidden="true"
                    >
                          <BaseSvg name="Check" aria-hidden="true" class="size-4" />
                          Sent
                    </span>
                </div>
            </div>
            <p class="mt-2 text-sm type-secondary"><span class="text-v2-red font-medium">Please note:</span> this is a SECLOCK branded email</p>
        </form>
    </li>
</template>

<script setup>
import {nextTick, ref} from "vue";
import {useCutSheet} from "@/Composables";
import {router} from "@inertiajs/vue3";

const isDropdownVisible = ref(false);
const sendButton = ref();
const sent = ref(false);
const { emailCutSheet, form, isSending } = useCutSheet();

const emailInput = ref();

function toggleForm() {
    isDropdownVisible.value = !isDropdownVisible.value;
    if(isDropdownVisible.value) {
        nextTick(() => {
            emailInput.value?.focus();
        });
    }
}

function sendEmail() {
    try {
        emailCutSheet(router.page?.props?.summary?.slug)
        flashSuccess();
    } catch (e) {
        console.log('Error:', e);
    }
}

function flashSuccess() {
    if (!sendButton.value) return
    sent.value = true;
    sendButton.value.classList.add('confirmation-run')
    setTimeout(() => {
        sendButton.value.classList.remove('confirmation-run')
        sent.value = false;
    }, 3000)
}
</script>
